<div *transloco="let t" class="d-flex flex-column">
  @if (showHeader()) {
    <h5>{{ t('Choose what to open:') }}</h5>
  }

  @if (userConfigsFacade.isSuperAdminSignal()) {
    <mat-form-field class="w-100">
      <mat-label>{{ t('Country') }}</mat-label>
      <mat-select
        required
        [compareWith]="helper.codeMatcher"
        [formControl]="countryControl()"
        (selectionChange)="onCountryChange()"
        data-cy="country-select">
        @for (country of countryList; track country) {
          <mat-option [value]="country"
            data-cy="country-option">
            {{ t(country?.name ?? '') }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  }
  <mat-form-field class="w-100">
    <mat-label>{{ t('Customer') }}</mat-label>
    <input
      matInput
      required
      [matAutocomplete]="customers"
      [formControl]="customerControl()"
      data-cy="country-customer-selection-input">
    <mat-error>
      {{ t(customerControl().errors | firstErrorMessage: customerErrors) }}
    </mat-error>
  </mat-form-field>

  <mat-autocomplete #customers [displayWith]="customerDisplayWith">
    @for (customer of filteredCustomers(); track customer.id) {
      <mat-option [value]="customer"
        data-cy="customer-option">
        {{ customer?.name ?? '' }}
      </mat-option>
    }
  </mat-autocomplete>
</div>
